import React from 'react';
import { Modal } from 'react-bootstrap';
import {
  askConfirmationUpdate,
  cancelConfirmReactivate,
  confirmReactivatePromo,
  hideConfirmReactivateModal,
  setActionUpdateName,
} from 'actions/businessLibrary/promo/promo';
import { connect } from 'react-redux';
import { mapKeys } from 'lodash';
import { libraryPromoDeleteReactivateDeactivate } from 'clevertap/library/promo';
import styles from './ConfirmReactivateModal.css';

class ConfirmReactivateModal extends React.Component {
  render() {
    const { showConfirmReactivateModal, detailPromo } = this.props;
    return (
      <Modal
        show={showConfirmReactivateModal}
        onHide={this._onHide}
        dialogClassName={`modal-dialog ${styles.dialog}`}
      >
        <Modal.Header bsClass={`modal-header ${styles.header}`}>
          <button
            onClick={this._onHide}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          Reactivate Promo
        </Modal.Header>
        <Modal.Body>
          {detailPromo && (
            <p>
              Are you sure you want to activate <b>{detailPromo.name}</b> ?
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button onClick={this._onHide} className="btn btn-default">
            Cancel
          </button>
          <button onClick={this._onConfirm} className="btn btn-primary">
            Reactivate
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  _onHide = () => {
    this.props.dispatch(cancelConfirmReactivate());
  };

  _onConfirm = () => {
    const {
      detailPromo,
      dispatch,
      outlets,
      isManager,
      hashedPromoType,
    } = this.props;
    const hashedOutlets = mapKeys(outlets, 'id');
    const outletNames = [];
    detailPromo.outlet_ids.forEach(oId => {
      if (hashedOutlets[oId]) {
        outletNames.push(hashedOutlets[oId].name);
      }
    });
    libraryPromoDeleteReactivateDeactivate('Promo Reactivate', {
      promoType: hashedPromoType[detailPromo.promo_type_id].name,
      promoName: detailPromo.name,
      outlet: outletNames,
    });
    if (isManager) {
      dispatch(hideConfirmReactivateModal());
      dispatch(setActionUpdateName('reactivate'));
      dispatch(
        askConfirmationUpdate(
          confirmReactivatePromo(detailPromo, hashedOutlets)
        )
      );
    } else {
      dispatch(confirmReactivatePromo(detailPromo, hashedOutlets));
    }
  };
}

function mapStateToProps(state) {
  const {
    detailPromo,
    showConfirmReactivateModal,
    outlets,
    promoTypes,
  } = state.businessLibrary.promo;
  const { user } = state.moka;
  const isManager = user.is_manager;
  const hashedPromoType = mapKeys(promoTypes, 'id');
  return {
    detailPromo,
    showConfirmReactivateModal,
    outlets,
    isManager,
    hashedPromoType,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmReactivateModal);
